import React from 'react';

function ReturnPolicy() {
  return (
    <div className="p-6 max-w-4xl  mt-48 mx-auto">
      <h1 className="text-2xl font-bold mb-4">Return Policy</h1>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">Shipment Terms:</h2>
        <ul className="list-disc pl-5">
          <li>All purchases are shipped under a shipment contract, transferring the risk and title to the buyer upon delivery to the carrier.</li>
          <li>Shipping and box fees are nonrefundable.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">Aquarium Supplies Returns:</h2>
        <ul className="list-disc pl-5">
          <li>Returns are accepted within 30 days for store credit. Electrical equipment can be returned within 30 days for exchange or store credit.</li>
          <li>Items must be unopened and in original packaging for full credit; opened or used items incur a 15% processing fee.</li>
          <li>Electrical equipment returns require valid proof, like video evidence, of any issues caused by usage or power.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">Live Fish Returns:</h2>
        <ul className="list-disc pl-5">
          <li>No returns for live fish, except for death during transit (proof required via unopened package photos).</li>
          <li>Saiaquapets is not responsible for fish deaths due to improper aquarium conditions. Customers must provide water parameters for verification.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">Refund Policy:</h2>
        <ul className="list-disc pl-5">
          <li>Refunds are processed within 45 days after approval.</li>
          <li>Orders from other states may take 60 days for processing.</li>
          <li>Refunds are credited to the original payment method or the user's wallet for server issues.</li>
          <li>Sale items are nonrefundable.</li>
          <li>Refunds for orders paid through GPay, UPI, PhonePe, or Paytm require matching bank account details.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">Exchanges:</h2>
        <p>Exchanges are accepted only for defective or damaged items. Contact support at <a href="mailto:support@saiaquapets.com" className="text-blue-600">support@saiaquapets.com</a>.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">Shipping Costs:</h2>
        <p>Buyers are responsible for shipping costs for returns, which are nonrefundable.</p>
      </section>
      
      <p className="mt-4">For more information, contact our support team at <a href="mailto:info@saiaquapets.com" className="text-blue-600">info@saiaquapets.com</a>.</p>
    </div>
  );
}

export default ReturnPolicy;
